import { Branded }		from "ts-base/branded";
import { Strings }		from "ts-base/strings";
import { Equal }		from "ts-base/equal";

/**
RFC 6750 b64token
as defined in https://datatracker.ietf.org/doc/html/rfc6750#section-2.1
*/
export type BearerToken	= Branded<string, "BearerToken">;

export namespace BearerToken {
	export const name		= "BearerToken";

	export const brand		= Branded.brand<BearerToken>;
	export const is			= (it:string):it is BearerToken	=> /^[a-zA-Z0-9\-._~+/]+=*$/.test(it);

	export const fromString	= (it:string):BearerToken|null	=> is(it) ? brand(it) : null;
	export const toString	= (it:BearerToken):string		=> it;

	export const equal:Equal<BearerToken>	= Strings.equal;
}
